import { isEmpty } from 'lodash-es';
import { MonsterSearch } from 'wisestep-api';
import { IFilterList } from 'wisestep-base';

export const pushSearchFilters = (data: MonsterSearch) => {
  const filtersArray: IFilterList[] = [];
  if (!isEmpty(data.relo))
    filtersArray.push({
      tag: `Work Auth.: ${data.relo}`,
      id: 'workAuthorizations',
    });
  return filtersArray;
};
